import * as tempusDominus from '@eonasdan/tempus-dominus';
import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.min.css';
import { _toPlainDate, _toLegacyBootstrapDateFormat } from './utilities.js';

var _dateTimePickerInstances = new WeakMap();

export function initDateTimePicker($picker, options) {
    if (!$picker || !$picker.length) {
        return null;
    }

    var pickerElement = $picker[0];
    var existingPicker = _dateTimePickerInstances.get(pickerElement);

    if (existingPicker) {
        return existingPicker;
    }

    var restrictions = {
        minDate: null,
        maxDate: null,
    };

    options = options || {};

    if (options.minDate) {
        restrictions.minDate = _toPlainDate(options.minDate);
    }

    if (options.maxDate) {
        restrictions.maxDate = _toPlainDate(options.maxDate);
    }

    var tdOptions = {
        display: {
            components: {
                calendar: true,
                date: true,
                month: true,
                year: true,
                decades: true,
                clock: false,
                hours: false,
                minutes: false,
                seconds: false,
            },
            buttons: {
                today: false,
                clear: false,
                close: false,
            },
        },
    };

    if (Object.keys(restrictions).some(function (key) {
        return restrictions[key] !== null;
    })) {
        tdOptions.restrictions = {
            minDate: restrictions.minDate,
            maxDate: restrictions.maxDate,
        };
    }

    if (options.format) {
        tdOptions.localization = {
            format: _toLegacyBootstrapDateFormat(options.format),
        };
    }

    if (options.defaultDate) {
        tdOptions.defaultDate = _toPlainDate(options.defaultDate);
    }

    if (options.useCurrent === false) {
        tdOptions.useCurrent = false;
    }

    var instance = new tempusDominus.TempusDominus(pickerElement, tdOptions);
    var hasTime = false;

    if (
        options.format &&
        (options.format.indexOf('h') !== -1 || options.format.indexOf('H') !== -1)
    ) {
        hasTime = true;
    }

    if (hasTime) {
        instance.options.display.components.clock = true;
        instance.options.display.components.hours = true;
        instance.options.display.components.minutes = true;
    }

    var wrapper = {
        pickerElement: pickerElement,
        instance: instance,
        show: function () {
            instance.show();
        },
        hide: function () {
            instance.hide();
        },
        minDate: function (date) {
            restrictions.minDate = _toPlainDate(date);
            instance.updateOptions({
                restrictions: {
                    minDate: restrictions.minDate,
                    maxDate: restrictions.maxDate,
                },
            });
        },
        maxDate: function (date) {
            restrictions.maxDate = _toPlainDate(date);
            instance.updateOptions({
                restrictions: {
                    minDate: restrictions.minDate,
                    maxDate: restrictions.maxDate,
                },
            });
        },
        date: function (newDate) {
            if (typeof newDate === 'undefined') {
                return instance.date;
            }

            if (newDate === null || newDate === false) {
                instance.clear();
            } else {
                instance.dates.setValue(new tempusDominus.DateTime(_toPlainDate(newDate)));
            }
        },
        destroy: function () {
            instance.dispose();
            _dateTimePickerInstances.delete(pickerElement);
        },
    };

    pickerElement.addEventListener('change.td', function (event) {
        var dpEvent = $.Event('dp.change');
        dpEvent.date = _toPlainDate(event.detail && event.detail.date);
        dpEvent.oldDate = _toPlainDate(event.detail && event.detail.oldDate);
        $picker.trigger(dpEvent);
    });

    _dateTimePickerInstances.set(pickerElement, wrapper);

    return wrapper;
}

export function getDateTimePicker($picker) {
    if (!$picker || !$picker.length) {
        return null;
    }

    return _dateTimePickerInstances.get($picker[0]) || null;
}
